import { render, staticRenderFns } from "./GradesManager.vue?vue&type=template&id=7ff1b27c&scoped=true"
import script from "./GradesManager.vue?vue&type=script&lang=js"
export * from "./GradesManager.vue?vue&type=script&lang=js"
import style0 from "./GradesManager.vue?vue&type=style&index=0&id=7ff1b27c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff1b27c",
  null
  
)

export default component.exports